import React from 'react';
import ReactDOM from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';
import { ENVIRONMENTS } from '@harvestiq/constants';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import { environmentConfig } from './environment-config';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';
import './styles/globals.scss';
import App from './App';
import { AppProvider } from './contexts/AppProvider';

const { env, version } = environmentConfig;
console.log(
  `Running portal client version: ${version} in '${env}' environment`
);

if (
  [ENVIRONMENTS.TEST, ENVIRONMENTS.STAGING, ENVIRONMENTS.PRODUCTION].includes(
    env
  )
) {
  datadogRum.init({
    applicationId: 'ba334cbf-f695-4164-b680-dda966614cd4',
    clientToken: 'pubc3168def0a909c5207d1faad1874b2d7',
    site: 'datadoghq.com',
    service: 'portal_client',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 80,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AppProvider>
        <App />
      </AppProvider>
    </HelmetProvider>
  </React.StrictMode>
);

if (
  !(
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.PRODUCTION &&
    process.env['NODE_ENV']?.toLowerCase() !== ENVIRONMENTS.TEST
  )
) {
  console.log('registering service worker');
  serviceWorkerRegistration.register();
} else {
  console.log('unregistering service worker');
  serviceWorkerRegistration.unregister();
}
